import { createRouter, createWebHistory } from 'vue-router';
import { tokenCheck, notRegisteredRoutePath, keepAliveCheck } from '@/router/navigationGuard';
import store from '@/store';

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', name: 'Login', component: () => import(/* webpackChunkName: "Basic" */ '@/views/Login') },
  {
    path: '/changePassword',
    name: 'ChangePassword',
    component: () => import(/* webpackChunkName: "Basic" */ '@/views/changePassword/')
  },
  {
    path: '/dashboard',
    name: 'DashBoard',
    component: () => import(/* webpackChunkName: "Dashboard" */ '@/views/dashboard/')
  },
  { path: '/chatting', name: 'Chat', component: () => import(/* webpackChunkName: "Chat" */ '@/views/chat/') },
  { path: '/order', name: 'Order', component: () => import(/* webpackChunkName: "Order" */ '@/views/order/') },
  {
    path: '/order/:orderNo',
    name: 'OrderDetail',
    component: () => import(/* webpackChunkName: "Order" */ '@/views/order/detail/')
  },
  {
    path: '/shop/list',
    name: 'StoreList',
    component: () => import(/* webpackChunkName: "Shop" */ '@/views/store/StoreList.vue')
  },
  {
    path: '/shop/:storeNo',
    name: 'StoreDetail',
    component: () => import(/* webpackChunkName: "Shop" */ '@/views/store/list/detail/StoreDashBoard.vue')
  },
  {
    path: '/shop/:storeNo/modify',
    name: 'StoreModify',
    component: () => import(/* webpackChunkName: "Shop" */ '@/views/store/list/detail/modify'),
    children: [
      {
        path: 'basic',
        name: 'StoreBasic',
        component: () =>
          import(/* webpackChunkName: "Shop" */ '@/views/store/list/detail/modify/components/StoreBasicInfo.vue')
      },
      {
        path: 'board',
        name: 'StoreBoard',
        component: () =>
          import(/* webpackChunkName: "Shop" */ '@/views/store/list/detail/modify/components/StoreBoard.vue')
      },
      {
        path: 'image',
        name: 'StoreImage',
        component: () =>
          import(/* webpackChunkName: "Shop" */ '@/views/store/list/detail/modify/components/StoreImage.vue')
      },
      {
        path: 'payment',
        name: 'StorePayment',
        component: () =>
          import(/* webpackChunkName: "Shop" */ '@/views/store/list/detail/modify/components/StorePaymentInfo.vue')
      },
      {
        path: 'sales',
        name: 'StoreSales',
        component: () =>
          import(/* webpackChunkName: "Shop" */ '@/views/store/list/detail/modify/components/StoreSales.vue')
      },
      {
        path: 'tip',
        name: 'StoreTip',
        component: () =>
          import(/* webpackChunkName: "Shop" */ '@/views/store/list/detail/modify/components/StoreDeliveryTip.vue')
      },
      {
        path: 'category',
        name: 'StoreCategory',
        component: () =>
          import(/* webpackChunkName: "Shop" */ '@/views/store/list/detail/modify/components/StoreCategory.vue')
      },
      {
        path: 'pos',
        name: 'StorePos',
        component: () =>
          import(/* webpackChunkName: "Shop" */ '@/views/store/list/detail/modify/components/StorePos.vue')
      }
    ]
  },
  {
    path: '/product/list',
    name: 'ProductList',
    component: () => import(/* webpackChunkName: "Product" */ '@/views/product/list/ProductList.vue')
  },
  {
    path: '/product/:productNo',
    name: 'ProductDetail',
    component: () => import(/* webpackChunkName: "Product" */ '@/views/product/list/detail/ProductInfo.vue')
  },
  {
    path: '/product/category',
    name: 'ProductCategoryList',
    component: () => import(/* webpackChunkName: "Product" */ '@/views/product/category/ProductCategoryList.vue')
  },
  {
    path: '/product/category/:productCategoryNo',
    name: 'ProductCategoryDetail',
    component: () => import(/* webpackChunkName: "Product" */ '@/views/product/category/ProductCategoryDetail.vue')
  },
  {
    path: '/product/recent',
    name: 'ProductRecent',
    component: () => import(/* webpackChunkName: "Product" */ '@/views/product/recent/')
  },
  { path: '/cs', name: 'Cs', component: () => import(/* webpackChunkName: "CS" */ '@/views/cs/') },
  {
    path: '/cs/:storeNo/:userNo',
    name: 'CsDetail',
    component: () => import(/* webpackChunkName: "CS" */ '@/views/cs/detail')
  },
  {
    path: '/coupon/issue',
    name: 'CouponIssue',
    component: () => import(/* webpackChunkName: "Coupon" */ '@/views/coupon/issue/CouponList.vue')
  },
  {
    path: '/coupon/issue/:couponNo',
    name: 'CouponIssueDetail',
    component: () => import(/* webpackChunkName: "Coupon" */ '@/views/coupon/issue/CouponInfo.vue')
  },
  {
    path: '/coupon/history',
    name: 'CouponHistory',
    component: () => import(/* webpackChunkName: "Coupon" */ '@/views/coupon/history/CouponSendHistory.vue')
  },
  {
    path: '/feedback/review',
    name: 'FeedbackReview',
    component: () => import(/* webpackChunkName: "Feedback" */ '@/views/feedback/review/')
  },
  {
    path: '/feedback/shop',
    name: 'FeedbackStore',
    component: () => import(/* webpackChunkName: "Feedback" */ '@/views/feedback/store/')
  },
  {
    path: '/feedback/product',
    name: 'FeedbackProduct',
    component: () => import(/* webpackChunkName: "Feedback" */ '@/views/feedback/product/')
  },
  {
    path: '/bizmoney/request',
    name: 'BizmoneyRequest',
    component: () => import(/* webpackChunkName: "Biz" */ '@/views/bizmoney/request/')
  },
  {
    path: '/bizmoney/request/:bizRequestNo',
    name: 'BizmoneyRequestDetail',
    component: () => import(/* webpackChunkName: "Biz" */ '@/views/bizmoney/request/detail/')
  },
  {
    path: '/bizmoney/request/charge',
    name: 'BizmoneyRequestCharge',
    component: () => import(/* webpackChunkName: "Biz" */ '@/views/bizmoney/request/charge/')
  },
  {
    path: '/bizmoney/transaction',
    name: 'BizmoneyTransaction',
    component: () => import(/* webpackChunkName: "Biz" */ '@/views/bizmoney/transaction/')
  },
  {
    path: '/bizmoney/transaction/:bizTransactionNo',
    name: 'BizmoneyTransactionDetail',
    component: () => import(/* webpackChunkName: "Biz" */ '@/views/bizmoney/transaction/detail/')
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkActiveClass: 'active'
});

router.beforeEach((to, from, next) => {
  keepAliveCheck(to, from);
  store.commit('common/setCheckedList');
  if (tokenCheck(to, from, next) && notRegisteredRoutePath(to, from, next)) {
    return next();
  } else next('/login');
});

export default router;
